import { createClient } from '@connectrpc/connect';
import { timestampDate } from '@bufbuild/protobuf/wkt';
import { CreativeWorkService } from '@buf/motto_cda.bufbuild_es/motto/cda/cms/creative_work/v1/service_pb';
import { cdaTransport, authHeaders } from './transport';

export interface CreativeWorkData {
  id: string;
  title: string;
  description?: string;
  releaseTime: string;
  endTime?: string;
  posterUrl?: string;
  videoIds?: string[];
  error?: string;
}

export enum CreativeWorksSortDirection {
  ASC = 'asc',
  DESC = 'desc'
}

const creativeWorkClient = createClient(CreativeWorkService, cdaTransport);

export async function fetchCreativeWorkData(
  publicKey: string,
  creativeWorkId: string,
  unused?: any,
  filter?: string,
  order?: CreativeWorksSortDirection,
  locale?: string
): Promise<CreativeWorkData> {
  // filter/order are not part of GetCreativeWorkRequest in the CDA schema; the
  // old fetch-based code sent them but the server ignored them.
  const response = await creativeWorkClient.getCreativeWork(
    {
      creativeWorkId,
      ...(locale?.length ? { locale } : {}),
    },
    { headers: authHeaders(publicKey) }
  );

  const creativeWork = response.creativeWork;
  if (!creativeWork) {
    throw new Error('Failed to fetch creative work data: empty response');
  }

  return {
    id: creativeWork.id,
    title: creativeWork.title,
    description: creativeWork.description || undefined,
    releaseTime: creativeWork.releaseTime ? timestampDate(creativeWork.releaseTime).toISOString() : '',
    posterUrl: creativeWork.posterUrl || undefined,
    videoIds: creativeWork.videoIds,
  };
}
